







import { Component, Vue } from "vue-property-decorator";
import ShaqFAQComponent from "@/components/ShaqFAQ.vue"; // @ is an alias to /src

@Component({
  components: {
    ShaqFAQ: ShaqFAQComponent
  }
})
export default class Home extends Vue {

}
